import { Controller } from "stimulus";
import OpSlider from './../components/opSlider/opSlider';

export default class extends Controller {
    static targets = [
        'frame',
        'list',
        'slide',
        'image',
    ];

    initialize() {
        this.onLoad = this.onLoad.bind(this);
    }

    connect() {

        window.addEventListener('load', this.onLoad);
    }


    onLoad() {
        const config = {
            slider: this.element,
            frame: this.frameTarget,
            list: this.listTarget,
            slides: this.slideTargets,
            mode: {
                // centered: true,
                fill: true,
                // infinite: true,
                multiple: true,
                // loop: true,
            },
            // autoplay: {
            //     duration: 4000,
            //     pauseOnHover: true,
            // },
        };

        this.slider = new OpSlider(config);

        this.element.addEventListener('dragstart', function (e) {
            e.preventDefault();
        });

        this.imageTargets.forEach((target) => {
            console.log(target);
            target.addEventListener('mouseover', this.handleMouseOver);
            target.addEventListener('mouseout', this.handleMouseOut);
        });
    }

    handleMouseOver = () => {
        this.element.classList.add('is-hovered');
    };

    handleMouseOut = () => {
        this.element.classList.remove('is-hovered');
    };
}


// WEBPACK FOOTER //
// ./mysite/resources/js/controllers/slider_controller.js